
const debugMode = window.location.href.startsWith("http://127.0.0.1") || window.location.href.startsWith("http://scgroup.com");

export { debugMode }